import { combineReducers } from 'redux';

import applicationReducer from './applications/applicationReducer';
import blacklistReducer from './blacklist/blacklistReducer';
import campaignReducer from './campaigns/campaignReducer';
import changelogReducer from './changelog/changelogReducers';
import contentSubmissionReducer from './contentSubmission/contentSubmissionReducer.ts';
import { customContractReducer } from './CustomContracts/reducer';
import dashboardReducer from './dashboard/dashboardReducer';
import { discoveryReducer } from './discovery/reducer';
import inboxReducer from './inbox/inboxReducer';
import listReducer from './lists/listReducer';
import notificationReducer from './notifications/notificationReducer';
import onboardingReducer from './onboarding/onboardingReducer';
import onboardingVideosReducer from './onboardingVideos/onboardingVideosReducer';
import relationshipReducer from './relationship/relationshipReducer';
import savingReducer from './saving/savingReducer';
import shortcutsReducer from './shortcuts/shortcutsReducer';
import sidebarReducer from './sidebar/sidebarReducer';
import socialListeningReducer from './socialListening/socialListeningReducer';
import stagesReducer from './stages/stagesReducer';
import { storeReducer } from './store/reducer';
import subscriptionReducer from './subscription/subscriptionReducer';
import userReducer from './user/userReducer';

const appReducer = combineReducers({
  subscription: subscriptionReducer,
  list: listReducer,
  campaigns: campaignReducer,
  onboarding: onboardingReducer,
  onboardingVideos: onboardingVideosReducer,
  user: userReducer,
  relationship: relationshipReducer,
  applications: applicationReducer,
  notifications: notificationReducer,
  changelog: changelogReducer,
  blacklist: blacklistReducer,
  socialListening: socialListeningReducer,
  stages: stagesReducer,
  inbox: inboxReducer,
  dashboardTutorials: dashboardReducer,
  shortcuts: shortcutsReducer,
  customContract: customContractReducer,
  discovery: discoveryReducer,
  sidebar: sidebarReducer,
  saving: savingReducer,
  store: storeReducer,
  contentSubmission: contentSubmissionReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
